import { EventEmitter } from '@angular/core';
var ExpiringPasswordStepComponent = /** @class */ (function () {
    function ExpiringPasswordStepComponent() {
        this.resetPassword = new EventEmitter();
        this.authWithoutResetPassword = new EventEmitter();
    }
    return ExpiringPasswordStepComponent;
}());
export { ExpiringPasswordStepComponent };
